import React, { FC, useState, useEffect } from "react";
import { DeletingLine } from "../DeletingLine/DeletingLine";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { deleteProcess } from "toolkit/steps/stepTwo/stepTwo.thunks";
import styles from "./EditionProcess.module.sass";
import { editProcess } from "toolkit/steps/stepTwo/stepTwo.thunks";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ModalWindow } from "components/ModalWindow/ModalWindow";
import { MyTextarea } from "../../MyTextarea/MyTextarea";
import { MyInput } from "../../MyInput/MyInput";
import { MySelect } from "../../MySelect/MySelect";
import { decreaseBpCount, increaseBpCount } from "toolkit/directories/directories.slice";

interface EditionProcessProps {
	close: () => void;
	process: any;
}

export const EditionProcess: FC<EditionProcessProps> = ({ close, process }) => {
	const [selectedClass, setSelectedClass] = useState<{
		id: number | null;
		name: string;
	}>({
		id: null,
		name: "",
	});
	const [name, setName] = useState<string>("");
	const [description, setDescription] = useState<string>("");
	const [reason, setReason] = useState<string>("");
	const [isSocial, setIsSocial] = useState<boolean>(false);
	const [isPolitic, setIsPolitic] = useState<boolean>(false);
	const [isEconomic, setIsEconomic] = useState<boolean>(false);
	const [isEcologic, setIsEcologic] = useState<boolean>(false);
	const [isDefense, setIsDefense] = useState<boolean>(false);
	const [isCriticality, setIsCriticality] = useState<boolean>(false);
	const [desireDelete, setDesireDelete] = useState<boolean>(false);
	// const { token } = useSelector((state: RootState) => state.stateProfile.profile);
	const dispatch = useAppDispatch();
	const [submitError, setSubmitError] = useState<boolean>(false);
	const [sequenceNumber, setSequenceNumber] = useState<string>("");
	const processClassesDirectory = useAppSelector((state) => state.directories.processClassesDirectory);
	const [loading, setLoading] = useState<boolean>(false);

	const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();

		if (!selectedClass.name || !name.trim() || !description.trim() || !reason.trim()) {
			setSubmitError(true);
		} else {
			setSubmitError(false);
			if (!dataChanged()) {
				close();
				return;
			}
			setLoading(true);
			dispatch(
				editProcess({
					process: {
						...process,
						selectedClass: selectedClass.id,
						name: name,
						shortDescription: description,
						reason: reason,
						sequenceNumber: sequenceNumber,
						isSocial: isSocial,
						isPolitic: isPolitic,
						isEconomic: isEconomic,
						isEcologic: isEcologic,
						isDefense: isDefense,
						isCriticality: isCriticality,
					},
					close,
				}),
			);
			changeClass();
		}
	};

	const dataChanged = (): boolean => {
		if (
			selectedClass.id !== process.clazz.id ||
			name !== process.name ||
			description !== process.shortDescription ||
			isSocial !== process.social ||
			isPolitic !== process.politic ||
			isEconomic !== process.economic ||
			isEcologic !== process.ecologic ||
			isDefense !== process.defense ||
			sequenceNumber !== process.sequenceNumber ||
			reason !== process.reason ||
			isCriticality !== process.criticality
		)
			return true;
		else return false;
	};

	const changeClass = () => {
		if (selectedClass.id && process.clazz.id !== selectedClass.id) {
			dispatch(increaseBpCount(selectedClass.id));
			dispatch(decreaseBpCount(process.clazz.id));
		}
	};

	// const deletingHandler = () => {
	//     dispatch(deleteProcessRequest(process.id, token))
	//     close();
	// }

	const deleteHandler = () => {
		dispatch(deleteProcess(process));
	};

	useEffect(() => {
		setSelectedClass(process.clazz);
		setName(process.name);
		setDescription(process.shortDescription);
		setIsSocial(process.social);
		setIsPolitic(process.politic);
		setIsEconomic(process.economic);
		setIsEcologic(process.ecologic);
		setIsDefense(process.defense);
		setSequenceNumber(process.sequenceNumber);
		setReason(process.reason);
		setIsCriticality(process.criticality);
		//eslint-disable-next-line
	}, []);

	return (
		<>
			{desireDelete && (
				<ModalWindow close={() => setDesireDelete(false)}>
					<DeletingLine
						close={() => setDesireDelete(false)}
						closeAll={close}
						toDelete={deleteHandler}
						title={"Удалить бизнес-процесс?"}
					/>
				</ModalWindow>
			)}
			<section className={styles.wrp}>
				<h4 className={styles.title}>Редактирование бизнес-процесса</h4>
				<Button onClick={() => setDesireDelete(true)} variant={BUTTON_VARIANTS.TEXT} className={styles.delete}>
					Удалить бизнес-процесс
				</Button>
				<form onSubmit={submitHandler} className={styles.form}>
					<div className={styles["form-wrp"]}>
						<div className={styles.item}>
							<MySelect
								list={processClassesDirectory}
								value={selectedClass.name}
								set={(selected) => {
									setSelectedClass(selected);
								}}
								name="Класс бизнес-процессов"
								placeholder="Класс"
								required={true}
								error={submitError}
								width="full"
							/>
						</div>
						<div className={styles.item}>
							<MyTextarea
								className={styles["area-name"]}
								value={name}
								set={(e) => setName(e.target.value)}
								name="Бизнес-процессы в деятельности организации"
								placeholder="Наименование бизнес-процесса"
								required={true}
								error={submitError}
							/>
						</div>
						<div className={styles.item}>
							<MyTextarea
								className={styles["area-description"]}
								value={description}
								set={(e) => setDescription(e.target.value)}
								name="Краткое описание бизнес-процессов в деятельности организации"
								placeholder="Описание бизнес-процесса"
								required={true}
								error={submitError}
							/>
						</div>
						<div className={styles.item}>
							<span className={styles.name}>Критерии значимости</span>
							<div className={styles["criteria-wrp"]}>
								<label className={styles["checkbox-label"]} htmlFor="1">
									<input
										checked={isSocial}
										onChange={() => {
											setIsSocial(!isSocial);
										}}
										className={styles.checkbox}
										type="checkbox"
										id="1"
									/>
									Социальная
								</label>
								<label className={styles["checkbox-label"]} htmlFor="2">
									<input
										checked={isPolitic}
										onChange={() => {
											setIsPolitic(!isPolitic);
										}}
										className={styles.checkbox}
										type="checkbox"
										id="2"
									/>
									Политическая
								</label>
								<label className={styles["checkbox-label"]} htmlFor="3">
									<input
										checked={isEconomic}
										onChange={() => {
											setIsEconomic(!isEconomic);
										}}
										className={styles.checkbox}
										type="checkbox"
										id="3"
									/>
									Экономическая
								</label>
								<label className={styles["checkbox-label"]} htmlFor="4">
									<input
										checked={isEcologic}
										onChange={() => {
											setIsEcologic(!isEcologic);
										}}
										className={styles.checkbox}
										type="checkbox"
										id="4"
									/>
									Экологическая
								</label>
								<label className={styles["checkbox-label"]} htmlFor="5">
									<input
										checked={isDefense}
										onChange={() => {
											setIsDefense(!isDefense);
										}}
										className={styles.checkbox}
										type="checkbox"
										id="5"
									/>
									Оборонная
								</label>
							</div>
						</div>
						<MyInput
							className={styles.item}
							name="Порядковый номер"
							placeholder={"МК-01"}
							value={sequenceNumber}
							set={(e) => {
								setSequenceNumber(e.target.value);
							}}
							maxLength={20}
						/>
						<div className={styles.item}>
							<MyTextarea
								className={styles["area-description"]}
								value={reason}
								set={(e) => setReason(e.target.value)}
								name="Описание возможных последствий"
								placeholder="Введите текст"
								required={true}
								error={submitError}
							/>
						</div>
						<div className={styles.item}>
							<span className={styles.name}>
								Заключение о критичности <span className="red">*</span>
							</span>
							<div className={styles["item-wrp"]}>
								<label className={styles.label} htmlFor="critical">
									<input
										checked={isCriticality}
										onChange={() => setIsCriticality(true)}
										className={styles.radio}
										name="criticality"
										type="radio"
										id="critical"
									/>
									Критический
								</label>
								<label className={styles.label} htmlFor="uncritical">
									<input
										checked={!isCriticality}
										onChange={() => setIsCriticality(false)}
										className={styles.radio}
										name="criticality"
										type="radio"
										id="uncritical"
									/>
									Некритический
								</label>
							</div>
						</div>
					</div>
					<div className={styles.btns}>
						<Button
							disabled={loading}
							onClick={close}
							type="button"
							variant={BUTTON_VARIANTS.OUTLINED}
							className={styles.button}>
							Отменить
						</Button>
						<Button loading={loading} type="submit" className={styles.button}>
							Готово
						</Button>
					</div>
				</form>
			</section>
		</>
	);
};
